import { CommonModule, NgFor, NgIf } from '@angular/common';
import {
 ChangeDetectionStrategy,
 Component,
 Inject,
 Input,
 OnChanges,
 Optional,
 SimpleChanges,
 computed,
 inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { BreadCrumb, SearchResponse } from '@core/models/domains/hotel';
import { SearchResultUiService } from '../../../search-result/services/search-result-ui.service';
import { DatepickerService } from '@shared/services/datepicker.service';
import { SearchBoxService } from '@shared/services/serach-box.service';

@Component({
 selector: 'iho-pdp-breadcrumb',
 standalone: true,
 imports: [NgIf, NgFor, RouterLink, RouterLink, FormsModule, CommonModule],
 templateUrl: './pdp-breadcrumb.component.html',
 styleUrls: ['./pdp-breadcrumb.component.scss'],
 changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdpBreadcrumbComponent implements OnChanges {
 @Input() dataSource?: BreadCrumb[];
 @Input() cityName?: string;
 @Input() hotelName?: string;
 router = inject(Router);
 route = inject(ActivatedRoute);
 cityId: string = '';
    searchBoxService = inject(SearchBoxService);
 accommodation = computed(() => this.searchBoxService.accommodation());
 constructor(
  private searchUiService: SearchResultUiService,
  private datepickerService: DatepickerService
 ) {
  let getParams = this.route.snapshot.queryParams;
  this.cityId = getParams['city'];
 }
 ngOnChanges(changes: SimpleChanges): void {}
 navToPlp(url: string, ev: Event,index:number) {
  ev.preventDefault();
  this.datepickerService.setState(false);
  if(index == 1 && this.accommodation() == 'ecolodge'){
      this.router.navigate([url]);
  }else{
      this.router.navigate([url], {
          queryParams: {
              search_box: this.cityName,
              refer: 'iranlist',
              date: this.datepickerService._startDate(),
              endDate: this.datepickerService._endDate(),
              type: 1,
              page: 1,
          }
      });
  }

 }
}
